export const KB_STATUSES = ["Draft", "In Review", "Published", "Archived", "Rejected"];
export const VISIBILITIES = ["Public", "Internal", "Restricted"];

export const STATUS_COLOR = {
  Draft: "slate", "In Review": "amber", Published: "green", Archived: "slate", Rejected: "red",
};
export const VISIBILITY_COLOR = { Public: "teal", Internal: "blue", Restricted: "violet" };

// Tenant roles selectable when a knowledge item is Restricted
export const RESTRICTABLE_ROLES = [
  "TENANT_ADMIN", "KNOWLEDGE_MANAGER", "KNOWLEDGE_AUTHOR",
  "SUPPORT_SUPERVISOR", "SUPPORT_AGENT", "SALES_MANAGER", "SALES_REP",
];

export const VISIBILITY_HINT = {
  Public: "Visible to anyone with knowledge access (and future customer portal).",
  Internal: "Visible to all authenticated staff with knowledge access.",
  Restricted: "Visible only to the selected roles — hidden from everyone else.",
};
